import { Client } from '@/utilities/api/Client';
import { RewardsProgramEndpoint } from '@api/endpoints/RewardsProgramEndpoint';
import { RetailerEndpoint } from "@api/endpoints";
import { QueryUtil } from '@/utilities/Query';
import { isEmpty } from 'lodash';

export class RewardsProgramApi {
  static create (
    body: RewardsProgramEndpoint.Create.Request,
  ): Promise<RewardsProgramEndpoint.Create.Response> {
    return Client(`rewards-programs`, {
      method: 'POST',
      body,
    });
  }

  static delete (id: string): Promise<void> {
    return Client(`rewards-programs/${id}`, { method: 'DELETE' });
  }

  static async getActiveProgramForRetailer (
    retailerId: string,
  ): Promise<RetailerEndpoint.GetActiveRetailerRewardsProgram.Response> {
    const program: RetailerEndpoint.GetActiveRetailerRewardsProgram.Response = await Client(
      `retailer/${retailerId}/active-rewards-program`,
    );
    // The endpoint answers 204 when there is no active program, which Client returns as {}.
    return isEmpty(program) ? null : program;
  }

  static hasActiveUsers (
    id: string,
  ): Promise<RewardsProgramEndpoint.HasActiveUsers.Response> {
    return Client(`rewards-programs/${id}/has-active-users`);
  }

  static hasPointsEngineBeenRun (
    id: string,
  ): Promise<RewardsProgramEndpoint.HasPointsEngineBeenRun.Response> {
    return Client(`rewards-programs/${id}/has-points-engine-been-run`);
  }

  static list (
    query: RewardsProgramEndpoint.List.Query,
  ): Promise<RewardsProgramEndpoint.List.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`rewards-programs?${queryString}`);
  }

  static saveTierOverride (
    id: string,
    body: RewardsProgramEndpoint.TierOverride.Request,
  ): Promise<RewardsProgramEndpoint.TierOverride.Response> {
    return Client(`rewards-programs/${id}/tier-override`, {
      method: 'POST',
      body,
    });
  }

  static update (
    id: string,
    body: RewardsProgramEndpoint.Update.Request,
  ): Promise<RewardsProgramEndpoint.Update.Response> {
    return Client(`rewards-programs/${id}`, {
      method: 'PATCH',
      body,
    });
  }
}
